<template>
  <div>
    <span class="titleTOP">{{t('账号登录')}}</span>
    <div class="divAccount">
      <img src="../../../assets/img/account.png" class="icon">
      <input ref="username" type="text" value="" class="username" autocomplete="off" :placeholder="t('请输入账号')">
    </div>
    <div class="divMima">
      <img src="../../../assets/img/password.png" class="icon">
      <input ref="password" :type="pwdInput" value="" class="pwd" autocomplete="off" :placeholder="t('请输入密码')">
      <Icon :type="eye" @click="lookPwd" style="position: absolute;right: 12px;top: 17px;font-size: 18px;"/>
    </div>
    <div class="divGdCode">
      <img src="../../../assets/img/code.png" class="icon">
      <input ref="gdCode" value="" class="gdCode" autocomplete="off" :placeholder="t('请输入固定验证码')">
    </div>
    <!-- <div class="divCode" v-if="loginType">
      <img src="../../assets/img/code.png" class="icon">
      <input ref="code" value="" class="pwd code" :placeholder="t('请输入验证码')">
    </div>
    <ErCode ref="ercode" :visible="loginType" @refresh="getNewCode" />
    <MoveBar ref="movebar"   v-if="moveBarshow" @on-change="moveChange"/> -->

    <div class="divToggle" v-if="loginType">
      <span class="sanjiao" >
        <img src="../../../assets/img/phone.png" class="toggle phone" @click="toggles">
      </span>
    </div>

  </div>
</template>

<script>
  // import i18n from '../../assets/js/i18n'
  import ErCode from "./components/ErCode";
  import MoveBar from "../Login/MoveBar.vue";

  export default {
    name: 'AccountLogin',
    components: { ErCode ,MoveBar},
    props: {
      loginType: {
        type: Boolean,
        default: false
      },
      TypeToggle: {
        type: Number,
        default: 1
      },
    },
    data() {
      return {
        eye: 'ios-eye-off',
        pwdInput: 'password',
        key: '',
        moveBarshow:window.ProjectConfig &&  window.ProjectConfig.moveBar,
        verifyBar:false  // 滑动条
      }
    },
    methods: {
      lookPwd() {
        if (this.pwdInput == 'password') {
          this.eye = 'ios-eye'
          this.pwdInput = 'text'
        } else {
          this.eye = 'ios-eye-off'
          this.pwdInput = 'password'
        }
      },
      login() {
        this.$parent.login()
      },
      toggles() {
        this.$emit('toggle', 2)
      },
      getNewCode(obj) {
        const { key } = obj;
        this.key = key
      },
      moveChange(val){
        // 滑动条
        this.verifyBar = val
      }
    }
  }

</script>
